import { Controller } from "@hotwired/stimulus"
import consumer from "../channels/consumer"

export default class extends Controller {
  static values = {
    queueEntryId: Number
  }

  connect() {
    this.subscription = consumer.subscriptions.create(
      {
        channel: "QueueEntryChannel",
        queue_entry_id: this.queueEntryIdValue
      },
      {
        received: (data) => {
          console.log('[QueueEntryController] Received broadcast:', data)
          if (data.action === 'update' && data.html) {
            // Replace the inner content of #queue-entry-status
            // This preserves the outer Stimulus controller wrapper
            const statusContainer = document.getElementById('queue-entry-status')
            if (statusContainer) {
              statusContainer.outerHTML = data.html
              console.log('[QueueEntryController] Queue entry status updated.')
            }
          }
        }
      }
    )
  }

  disconnect() {
    if (this.subscription) {
      this.subscription.unsubscribe()
    }
  }
}
